export default "__VITE_ASSET__66583737__"